import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11 17h2v-6h-2Zm1-8q.425 0 .713-.288Q13 8.425 13 8t-.287-.713Q12.425 7 12 7t-.712.287Q11 7.575 11 8t.288.712Q11.575 9 12 9Zm0 13q-2.075 0-3.9-.788-1.825-.787-3.175-2.137-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175 1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138 1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175-1.35 1.35-3.175 2.137Q14.075 22 12 22Zm0-2q3.35 0 5.675-2.325Q20 15.35 20 12q0-3.35-2.325-5.675Q15.35 4 12 4 8.65 4 6.325 6.325 4 8.65 4 12q0 3.35 2.325 5.675Q8.65 20 12 20Zm0-8Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-full px-2" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "border-b-2 pb-2 text-lg text-darker" }, "Spotium")
], -1)
const _hoisted_5 = { class: "space-y-2 px-2" }
const _hoisted_6 = { class: "font-bold text-darker" }
const _hoisted_7 = { class: "text-darkgrey" }
const _hoisted_8 = { class: "text-darkgrey" }
const _hoisted_9 = { class: "font-bold text-darker" }
const _hoisted_10 = { class: "flex flex-col space-y-1" }
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdown_wrapper = _resolveComponent("dropdown-wrapper")!
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass(`cursor-pointer fill-darkgrey hover:fill-primary ${
        _ctx.isVersionDropdownOpened && 'fill-primary'
      }`),
      height: "24",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, _hoisted_3, 2)),
    _createVNode(_component_dropdown_wrapper, { "is-dropdown-opened": _ctx.isVersionDropdownOpened }, {
      default: _withCtx(() => [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("VersionDropdown.Version")), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.config.VERSION), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.config.VERSION_DATE), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("VersionDropdown.LegalInformation")), 1),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legalInformation, (information) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: information.id,
                  href: information.url,
                  class: "mt-2 text-xs text-primary hover:underline",
                  target: "_blank"
                }, _toDisplayString(_ctx.$t(information.label)), 9, _hoisted_11))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["is-dropdown-opened"])
  ])), [
    [_directive_click_away, _ctx.isVersionDropdownOpened && _ctx.toggleDropdown]
  ])
}